import React from "react";
import PdfDocumentTable from "../../../rightToInformation/components/RtiContent/PdfDocumentTable";
import lendingPolicyPdf from "../../../../assets/tenders/resource/Lending_policyEnglishNo13-09-2022CTPpdf-85842b6d8098aa6793a83f4aba51178f.pdf";

const lendingPolicyDocuments = [
  {
    serial: 1,
    title: "Lending Policy",
    fileName:
      "Lending_policyEnglishNo13-09-2022CTPpdf-85842b6d8098aa6793a83f4aba51178f.pdf",
    href: lendingPolicyPdf,
  },
];

const LendingPolicy = () => (
  <section className="min-w-0 flex-1">
    <h2 className="mb-3 text-[18px] font-bold text-[#005856]">
      Lending Policy
    </h2>
    <PdfDocumentTable
      documents={lendingPolicyDocuments}
      minWidth="680px"
      showSerial={false}
    />
  </section>
);

export default LendingPolicy;
